// extracted by mini-css-extract-plugin
export default {"messageText":"messageText___ktWGN_common"};